import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-X15L0PZ7T6", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}